import { useState, useRef } from 'react'

export default function PullToRefresh({ onRefresh, children }) {
  const [isPulling, setIsPulling] = useState(false)
  const [pullDistance, setPullDistance] = useState(0)
  const startY = useRef(0)
  const isRefreshing = useRef(false)

  const handleTouchStart = (e) => {
    if (window.scrollY === 0) {
      startY.current = e.touches[0].clientY
    }
  }

  const handleTouchMove = (e) => {
    if (window.scrollY === 0 && !isRefreshing.current) {
      const currentY = e.touches[0].clientY
      const distance = currentY - startY.current

      if (distance > 0) {
        setIsPulling(true)
        setPullDistance(Math.min(distance, 80))
      }
    }
  }

  const handleTouchEnd = async () => {
    if (pullDistance > 60 && !isRefreshing.current) {
      isRefreshing.current = true
      setIsPulling(true)
      setPullDistance(60)
      
      try {
        await onRefresh()
      } catch (error) {
        console.error('Refresh error:', error)
      } finally {
        setTimeout(() => {
          isRefreshing.current = false
          setIsPulling(false)
          setPullDistance(0)
        }, 300)
      }
    } else {
      setIsPulling(false)
      setPullDistance(0)
    }
  }

  return (
    <div
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      style={{ 
        transform: `translateY(${pullDistance}px)`,
        transition: isPulling && pullDistance === 60 ? 'transform 0.3s' : 'none'
      }}
    >
      {isPulling && (
        <div 
          className="flex justify-center items-center py-4"
          style={{
            opacity: pullDistance / 80,
            transition: 'opacity 0.2s'
          }}
        >
          <div className="flex items-center gap-2 text-blue-600">
            {isRefreshing.current ? (
              <>
                <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span className="text-sm font-medium">Refreshing...</span>
              </>
            ) : pullDistance > 60 ? (
              <span className="text-sm font-medium">Release to refresh</span>
            ) : (
              <span className="text-sm font-medium">Pull to refresh</span>
            )}
          </div>
        </div>
      )}
      
      {children}
    </div>
  )
}